import useVersionCheck from "../lib/useVersionCheck";
import { RefreshCw, X } from "lucide-react";

/**
 * Non-blocking toast-style banner shown when a new frontend build is detected.
 * Anchors bottom-right so it never covers order forms or kitchen actions.
 * See useVersionCheck.js for detection + auto-reload-on-navigate logic.
 */
export default function VersionBanner() {
  const { hasNew, refreshNow, snooze } = useVersionCheck();
  if (!hasNew) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="version-banner"
      className="fixed bottom-5 right-5 z-[60] max-w-sm luxury-card-elevated px-4 py-3 flex items-start gap-3 animate-in slide-in-from-bottom-4"
    >
      <RefreshCw className="h-4 w-4 mt-0.5 text-[hsl(var(--primary))]" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium">A new version is available.</div>
        <div className="mt-2 flex items-center gap-3">
          <button
            type="button"
            onClick={refreshNow}
            data-testid="version-banner-refresh"
            className="h-8 px-3 rounded-lg bg-foreground text-background text-xs font-medium hover:bg-foreground/90"
          >
            Refresh now
          </button>
          <button
            type="button"
            onClick={snooze}
            data-testid="version-banner-later"
            className="text-xs text-muted-foreground hover:text-foreground"
          >
            Later
          </button>
        </div>
      </div>
      <button
        type="button"
        onClick={snooze}
        aria-label="Dismiss"
        className="text-muted-foreground hover:text-foreground -mt-0.5 -mr-1"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
